import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import './styles.css';
import { Device } from '../../../../../../../types/Device';
import { ReactComponent as SvgClose } from 'utils/app/assets/icons/Close.svg';
import { CameraGridManualPosition } from '../CameraGridManualPosition/CameraGridManualPosition';

interface DevicePositionModalProps {
    visible: boolean;
    onOk: () => void;
    onCancel: () => void;
    currentPosition: number | null;
    onPositionChange: (oldPosition: number, newPosition: number) => void;
    devices: Device[];
    currentDevice: Device | null;
    layoutViewType: '2x2' | '1х5' | '3х4' | '3х3' | '2х8' | '1х12' | '4х4' | '1х7';
    setIsModalVisible: (visible: boolean) => void;
}

const DevicePositionModal: React.FC<DevicePositionModalProps> = ({
    visible,
    onOk,
    onCancel,
    currentPosition,
    onPositionChange,
    devices,
    currentDevice,
    layoutViewType,
    setIsModalVisible,
}) => {
    const [selectedPosition, setSelectedPosition] = useState<number | null>(currentPosition);

    const handleTileClick = (position: number) => {
        console.log('position', position);
        setSelectedPosition(position);
    };

    const handleOk = () => {
        if (selectedPosition !== null && currentDevice) {
            const oldPosition = devices.findIndex((d) => d.UID === currentDevice.UID);
            onPositionChange(oldPosition, selectedPosition);
        }
        onOk();
        setIsModalVisible(false);
    };
    return (
        <Modal
            className="devicePosition"
            title={
                <div className="modal_header headline small">
                    <span className="modal-title">{'Выберите новую позицию устройства'}</span>
                    {<SvgClose className="custom-close-icon" onClick={onCancel} />}
                </div>
            }
            visible={visible}
            onOk={handleOk}
            onCancel={onCancel}
            okText="Подтвердить"
            cancelText="Отмена"
            footer={[
                <Button
                    key="ok"
                    className="button-base button-type-primary button-size-medium "
                    onClick={handleOk}
                >
                    Подтвердить
                </Button>,
            ]}
        >
            <div className="preview-grid">
                <CameraGridManualPosition
                    viewType={layoutViewType}
                    devices={devices}
                    selectedPosition={selectedPosition}
                    onTileClick={handleTileClick}
                    currentDeviceId={currentDevice?.UID}
                />
            </div>
        </Modal>
    );
};

export default DevicePositionModal;
